import {defineStore} from 'pinia'
import {ref, unref} from 'vue'
import {statuses} from '@/constants/statuses.js'

/**
 * Messages store
 */
export const useFlashMessagesStore = defineStore('flashMessages', () => {

  //Container for flash messages
  const flashMessages = ref([])

  //Helper to generate a flash message object
  const createFlashMessage = (text, type, timeout) => ({
    id: Math.random().toString(36).substring(2, 9),
    text: unref(text),
    type: unref(type),
    timeout: unref(timeout),
  })

  //Show message
  const showFlashMessage = (text, type, timeout = 5000) => {

    //Must have text
    if (!text) {
      return
    }

    //Unref timeout
    timeout = unref(timeout)

    //Create message object
    const message = createFlashMessage(text, type, timeout)

    //Add to container
    flashMessages.value = [...flashMessages.value, message]

    //Create timeout to hide message
    if (timeout > 0) {
      setTimeout(() => hideFlashMessage(message.id), timeout)
    }

    //Return the created message
    return message
  }

  //Hide message by ID
  const hideFlashMessage = messageId => {
    flashMessages.value = flashMessages.value
      .filter(message => message.id !== messageId)
  }

  //Convenience helpers
  const setFlashSuccess = (text, timeout) => showFlashMessage(text, statuses.SUCCESS, timeout)
  const setFlashFailure = (text, timeout) => showFlashMessage(text, statuses.DANGER, timeout)

  //Expost interface
  return {

    //Flash messages container
    flashMessages,

    //Generic controls
    showFlashMessage,
    hideFlashMessage,

    //Convenience helpers
    setFlashSuccess,
    setFlashFailure,
    createFlashMessage,
  }
})
